module.exports = __webpack_public_path__ + "static/img/maps.bef0f48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maps.png
// module id = 249
// module chunks = 1